import React from 'react'
import styled, { css } from 'styled-components'

/** Apply on LP compose / page-details counters only — not on product or admin forms. */
export const LP_CHARACTER_COUNTER_CLASS = 'lp-character-counter'

export type CharacterCounterVariant = 'default' | 'landingPage'

interface CharacterCounterProps {
  currentLength: number
  maxLength?: number
  className?: string
  color?: 'default' | 'orange' | 'red'
  variant?: CharacterCounterVariant
}

export const CharacterCounter: React.FC<CharacterCounterProps> = ({
  currentLength,
  maxLength,
  className,
  color,
  variant = 'default'
}) => {
  const isExceeded = typeof maxLength === 'number' && currentLength > maxLength
  const displayColor = color || (isExceeded ? 'red' : 'default')
  const mergedClassName = [
    className,
    variant === 'landingPage' ? LP_CHARACTER_COUNTER_CLASS : undefined
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <CounterWrapper
      className={mergedClassName || undefined}
      $isExceeded={isExceeded}
      $color={displayColor}
      $variant={variant}
    >
      {typeof maxLength === 'number'
        ? `${currentLength}/${maxLength}`
        : `${currentLength}`}
    </CounterWrapper>
  )
}

const CounterWrapper = styled.div<{
  $isExceeded: boolean
  $color?: 'default' | 'orange' | 'red'
  $variant: CharacterCounterVariant
}>`
  font-size: 12px;
  color: ${({ $isExceeded, $color, theme }) => {
    if ($color === 'red') return theme.colors.error
    if ($color === 'orange') return '#ed6c02'
    if ($isExceeded) return theme.colors.error

    return theme.colors.muiLabel
  }};
  text-align: left;
  font-weight: ${({ $isExceeded, $color }) =>
    $isExceeded || $color === 'red' ? '600' : '400'};
  position: relative;
  z-index: ${({ theme }) => theme.zIndex.medium};
  display: block;
  width: 100%;
  padding-left: 14px;

  ${({ $variant }) =>
    $variant === 'default' &&
    css`
      margin-top: 4px;
      padding-top: 5px;
      line-height: normal;
    `}

  ${({ $variant }) =>
    $variant === 'landingPage' &&
    css`
      margin-top: 2px;
      padding-top: 0;
      line-height: 1.2;
    `}

  &.lp-character-counter {
    margin-top: 2px;
    padding-top: 0;
    line-height: 1.2;
  }
`
